import type { SVGProps } from "react";

export const FolderIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className="fill-current"
      {...props}
    >
      <path
        d="M9.75 4.5C10.0008 4.5 10.2349 4.62534 10.374 4.83398L11.6514 6.75H18C18.5967 6.75 19.1689 6.98722 19.5908 7.40918C20.0128 7.83114 20.25 8.40326 20.25 9V17.25C20.25 17.8467 20.0128 18.4189 19.5908 18.8408C19.1689 19.2628 18.5967 19.5 18 19.5H6C5.40326 19.5 4.83114 19.2628 4.40918 18.8408C3.98722 18.4189 3.75 17.8467 3.75 17.25V6.75C3.75 6.15326 3.98722 5.58114 4.40918 5.15918C4.83114 4.73722 5.40326 4.5 6 4.5H9.75ZM6 6C5.80109 6 5.61038 6.07907 5.46973 6.21973C5.32907 6.36038 5.25 6.55109 5.25 6.75V17.25C5.25 17.4489 5.32907 17.6396 5.46973 17.7803C5.61038 17.9209 5.80109 18 6 18H18C18.1989 18 18.3896 17.9209 18.5303 17.7803C18.6709 17.6396 18.75 17.4489 18.75 17.25V9C18.75 8.80109 18.6709 8.61038 18.5303 8.46973C18.3896 8.32907 18.1989 8.25 18 8.25H11.25C10.9992 8.25 10.7651 8.12466 10.626 7.91602L9.34863 6H6Z"
        fill="currentColor"
      />
    </svg>
  );
};
